import API from '@/services/endpoint'
import { SET_CURRENT_BOOKING_EVENT } from "../../mutation-types";

/**
 * Set current clicked event to be booked
 * @param {function} commit - The vuex commit function
 * @param payload
 * @param {object} state - The vuex state object
 * @return {object} A object of current event
 */
export async function setCurrentEvent({commit}, payload) {
  commit(SET_CURRENT_BOOKING_EVENT, payload)
}

/**
 * Post request for event reservation
 * @param {function} commit - The vuex commit function
 * @param payload
 * @param {object} state - The vuex state object
 * @return {object} A object of current event information
 */
export function postEventHandler({commit, state}, payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { url } = state
      let responseObj = await API.post(url, payload);
      // Return full message object so callers can access reservation id for redirects
      const data = responseObj && responseObj.data ? responseObj.data : null
      const message = data && data.message ? data.message : data
      resolve(message)
    } catch (e) {
      // Safely access response data, fallback to error message if response is undefined
      const errorData = e.response && e.response.data ? e.response.data : { message: e.message || 'An error occurred' }
      reject(errorData)
    }
  })
}
